export enum PricingSignalStatus {
  pending = 'pending',
  executed = 'executed',
}
